var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"hidden-print-only md-font",staticStyle:{"z-index":"0","background":"none","color":"#999"},attrs:{"padless":"","absolute":""}},[_c('v-col',{staticClass:"text-center md-font",attrs:{"cols":"12"}},[_vm._v(" Version "+_vm._s(_vm.$app_version)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }